module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNpi/P//PwM1ABMDlQDVDGIBEes3b6fIkEBfT9p4LR+IXwHxfyLwNyB+CMSK2AxyBeKJQNxBwPJ3QOwPxK+BWAtXYLcA8S8gLsZhyAsgDgXidiA2JhRrdVAnxwHxXyTxO1BDpqEbgi/6c6BeBWn8DsQXgDgRiJcCsTrO6McCPkLpBCD2hLIXAfE+qBhRBoEM6QbiaiDmBGJ+qCskoGE0C4jTCHkNZEgfkiEgYA81BAQsgVgXiKfjcxHIkPVAXIFkCDYAMowZiI9DYxjDoCZoIC8mMjE/AuKD2Ay6CcS55GYRxkFXHgEEGAB/3zh2APPOdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconMail.png
// module id = 818
// module chunks = 114276838955818